import axios from "axios";

const timeZoneUrl = "api/v1/time_zone";

const updateTimeZone = payload => axios.patch(timeZoneUrl, payload);

const timeZoneApi = { updateTimeZone };

export default timeZoneApi;
